import { supabase } from '../lib/supabase';
import { FramingSettings } from '../types';

export interface DiscoverSettings {
    id: string;

    hero_badge: string;
    hero_title: string;
    hero_description: string;

    classic_image_url: string;
    classic_image_mobile_url: string;
    classic_framing_settings?: FramingSettings;
    classic_badge: string;
    classic_title: string;
    classic_description: string;

    forged_image_url: string;
    forged_image_mobile_url: string;
    forged_framing_settings?: FramingSettings;
    forged_badge: string;
    forged_title: string;
    forged_description: string;

    magsafe_title: string;
    magsafe_description: string;
    magsafe_framing_settings?: FramingSettings;

    unboxing_badge: string;
    unboxing_title: string;
    unboxing_description: string;
    unboxing_image_url: string;
    unboxing_image_mobile_url: string;
    unboxing_framing_settings?: FramingSettings;

    unboxing_feature_1: string;
    unboxing_feature_2: string;
    unboxing_feature_3: string;

    cta_title: string;
    is_maintenance_mode?: boolean;
}

const SETTINGS_ID = '00000000-0000-0000-0000-000000000000';

class DiscoverService {
    async getSettings(): Promise<DiscoverSettings | null> {
        const { data, error } = await supabase
            .from('discover_settings')
            .select('*')
            .eq('id', SETTINGS_ID)
            .single();

        if (error) {
            console.error('Error fetching discover settings:', error);
            return null;
        }

        const settings = data as DiscoverSettings;
        if (settings) {
            const framing = (settings.unboxing_framing_settings || {}) as any;
            if (typeof framing.is_maintenance_mode === 'boolean') {
                settings.is_maintenance_mode = framing.is_maintenance_mode;
            } else {
                settings.is_maintenance_mode = false;
            }
        }

        return settings;
    }

    async updateSettings(settings: Partial<DiscoverSettings>): Promise<boolean> {
        const payload: any = { ...settings };

        if (typeof settings.is_maintenance_mode === 'boolean') {
            const current = await this.getSettings();
            const framing = (current?.unboxing_framing_settings || {}) as any;
            payload.unboxing_framing_settings = {
                ...framing,
                is_maintenance_mode: settings.is_maintenance_mode
            };
            delete payload.is_maintenance_mode;
        }

        const { error } = await supabase
            .from('discover_settings')
            .update(payload)
            .eq('id', SETTINGS_ID);

        if (error) {
            console.error('Error updating discover settings:', error);
            return false;
        }

        return true;
    }
}

export const discoverService = new DiscoverService();
